import {API_URL,CHECK_STORE_CLERK,ORDERSEARCH_PAGE,STORE_CLERK_LOGIN,
  STORE_CLERK_LOGOUT_URL,GET_MOQUI_SESSION,CLERKLOGIN_PAGE,GET_API_TOKEN,PRODUCTION_PATH}  from "../../AppConfig";  
 

// Store Clerk Authentication
export  const checkStoreClerk = (data,ownProps) => { 

return async dispatch => {   

    // fetch Moqui Session Token 
      let sessionId="";  
          sessionId = await fetch(GET_MOQUI_SESSION, {
            method: "GET",
            headers: { Accept: "text/plain" }
          }).then(response => response.text()); 

      let checkStoreClerkURL = API_URL+STORE_CLERK_LOGIN;
      let storeClerkLoginData ={ "username":data.username,
                        "password" : data.password,
                        "storeId" : data.storeId,
                        "moquiSessionToken" : sessionId
                        }      

      await fetch(checkStoreClerkURL,
               {method:'POST',
                headers: {"content-type": "application/json" },
                body: JSON.stringify(storeClerkLoginData)
        })
          .then(res => res.json())
          .then(loginData => {  

                dispatch({ 
                type:CHECK_STORE_CLERK, 
                errorMessage: loginData.errors, 
                username:data.username+' ',
                password:data.password
              })        

        // If the user is valid then generate API token and redirect to the Order Search page  
              if(loginData.errors === '' )  {               
                // get api key for store clerk
                  fetch(GET_API_TOKEN, {
                    method: "GET",
                    headers: {"Authorization": "Basic " + btoa(data.username + ":" + data.password)},
                  }).then(response => response.text())
                    .then(res =>{                       
                      window.sessionStorage.setItem('storeClerkToken',res);
                      window.sessionStorage.setItem('storeClerk',data.username);
                      let orderSearchPageURL = PRODUCTION_PATH+data.storeId+ORDERSEARCH_PAGE; 
                      ownProps.history.push(orderSearchPageURL); 
                    })  
              }  
          }).catch(function(error) {
            console.log(error);
        });; 
   }

  }

// logout 
export  const logout = (data,ownProps) => {  
    return dispatch =>{
      let logoutURL =API_URL +STORE_CLERK_LOGOUT_URL; 
      fetch(logoutURL, {
        method:'GET' ,
        headers: {"api_key": data.apiToken}
      }) 
        .then( res => {           
          window.sessionStorage.removeItem('storeClerkToken');
          window.sessionStorage.removeItem('orderListing');
          window.sessionStorage.removeItem('orderData');          
          window.sessionStorage.removeItem('storeClerk');
          let loginPageURL = PRODUCTION_PATH+data.storeId+CLERKLOGIN_PAGE;
          ownProps.history.push(loginPageURL);
        }
        );  
      }
}
export const logoutMoquiSession = (apiToken) =>{
  let logoutURL =API_URL +STORE_CLERK_LOGOUT_URL; 
  fetch(logoutURL, {
    method:'GET' ,
    headers: {"api_key": apiToken}
  }).then( res => {
      console.log("success logout!", res)
    });
}


// WEBPACK FOOTER //
// ./src/redux/actions/loginAction.js